import { defineMessages } from 'react-intl'

export default defineMessages({
    placePlaceholder: {
        defaultMessage: 'Ciudad, aeropuerto y/o estaciones',
    },
    datePlaceholder: {
        defaultMessage: 'Fecha',
    },
    hourPlaceholder: {
        defaultMessage: 'Hora',
    },
    mobileDatePlaceholder: {
        defaultMessage: 'Fecha y hora',
    },
    pickUpLabel: {
        defaultMessage: 'Lugar de recogida y devolución',
    },
    pickUpLabelWithSameLocation: {
        defaultMessage: 'Lugar de recogida',
    },
    returnLabel: {
        defaultMessage: 'Lugar de devolución',
    },
    pickUpDateLabel: {
        defaultMessage: 'Fecha y hora de recogida',
    },
    returnDateLabel: {
        defaultMessage: 'Fecha y hora de devolución',
    },
    submitButton: {
        defaultMessage: 'Buscar',
    },
    isDifferentOfficeLabel: {
        defaultMessage: 'Devolución en otra oficina',
    },
    isMutuaCheckLabel: {
        defaultMessage: 'Soy usuario MutuaMás y/o mutualista',
    },
    pickUpPlaceError: {
        defaultMessage: 'Obligatorio: Elige la oficina donde quieres recoger el vehículo',
    },
    returnPlaceError: {
        defaultMessage: 'Obligatorio: Elige la oficina donde quieres devolver el vehículo',
    },
    pickUpTimeError: {
        defaultMessage: 'Elige la fecha de recogida',
    },
    returnTimeError: {
        defaultMessage: 'Elige la de devolución',
    },
    ageSelector1: {
        defaultMessage: '18 años',
    },
    ageSelector2: {
        defaultMessage: '19 años',
    },
    ageSelector3: {
        defaultMessage: '20 años',
    },
    ageSelector4: {
        defaultMessage: '21 años',
    },
    ageSelector5: {
        defaultMessage: '22 años',
    },
    ageSelector6: {
        defaultMessage: '23 años',
    },
    ageSelector7: {
        defaultMessage: '24 años',
    },
    ageSelector8: {
        defaultMessage: '25 años',
    },
    ageSelector9: {
        defaultMessage: '26 años',
    },
    ageSelector10: {
        defaultMessage: '27 años',
    },
    ageSelector11: {
        defaultMessage: '28-75 años',
    },
    ageSelector12: {
        defaultMessage: '+75 años',
    },
    ariaPickUpPlaceInputDescription: {
        defaultMessage: 'Campo de texto para seleccionar la oficina de recogida del vehículo',
    },
    ariaReturnPlaceInputDescription: {
        defaultMessage: 'Campo de texto para seleccionar la oficina de devolución del vehículo',
    },
})
